import React, { useMemo } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";

export const ModalTimesheetProBonoResumo = ({ isOpen, onAfterOpen, onRequestClose, resumo, resumoAtividades }) => {
  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
  }
  const style = {
      content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: "0px",
          minWidth: '35%',
          overflowY: 'auto',
          minHeight: '45%',
          maxHeight: '90%',
          maxWidth: '100%'
      },
        overlay: {
            zIndex: 9999
        }
  };

  const colunas = useMemo(() => [{
    columns: [
      {
        Header: "Profissional"
      },
      {
        Header: "Laudo"
      },
      {
        Header: "TimeSheet"
      },
      {
        Header: "Horas"
      },
      {
        Header: "Valor"
      }]
    }],
  []);

  const colunas_atividades = useMemo(() => [{
      columns: [
        {
          Header: "Atividade"
        },
        {
          Header: "Laudo"
        },
        {
          Header: "TimeSheet"
        },
        {
          Header: "Horas"
        },
        {
          Header: "Valor"
        }]
      }],
  []);

  return (
    <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        contentLabel="Timesheet Atividades"
        style={style}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
    >
      <StyledForm>
        <p className="modal-close" onClick={onRequestClose}>X</p>
      </StyledForm>                       
      <Flex>
          <StyledForm style={{width: "100%"}}>
              <Flex>
                  <Flex.Item className="modal-width">
                      <div className="position-relative form-group">                  
                          <p className="modal-title">Resumo Profissionais - Pro bono</p>                                                        
                      </div>
                  </Flex.Item>
              </Flex>                             
              <StyledTablePage>
                  <table className="table table-bordered table-width">
                      <thead>
                          <tr className="table-legend-info">
                          {colunas[0].columns.map(column => (
                              <th key={column.Header}>{column.Header}</th>
                          ))}
                          </tr>
                      </thead>
                      <tbody>
                          {resumo?.filter(f=> f.totalHorasProBono != "0,00").map(profissional => (
                              <tr 
                                  key={profissional.idUsuarioPerito} 
                                  className={`table-data-info ${profissional.idUsuarioPerito == -1 ? 'tableFooter' : ''}`}
                              >
                                  <td>{profissional.nome}</td>
                                  <td>{profissional.laudo}</td>
                                  <td>{profissional.timesheet}</td>
                                  <td>{profissional.totalHorasProBono}</td>
                                  <td>{profissional.totalValorProBono}</td>
                              </tr>
                          ))}
                      </tbody>
                  </table>
              </StyledTablePage>
              <Flex>
                  <Flex.Item className="modal-width">
                      <div className="position-relative form-group">                  
                          <p className="modal-title">Resumo Atividades - Pro bono</p>                                                        
                      </div>
                  </Flex.Item>
              </Flex> 
              <StyledTablePage>
                  <table className="table table-bordered table-width">
                      <thead>
                          <tr className="table-legend-info">
                          {colunas_atividades[0].columns.map(column => (
                              <th key={column.Header}>{column.Header}</th>
                          ))}
                          </tr>
                      </thead>
                      <tbody>
                          {resumoAtividades.filter(f => f.totalValorProBono != "R$ 0,00").map((atividade, index) => (
                            <tr key={index} className={`table-data-info ${atividade.idAtividade == -1 ? 'tableFooter' : ''}`}>
                                <td>{atividade.atividade}</td>
                                <td>{atividade.laudo}</td>
                                <td>{atividade.timesheet}</td>
                                <td>{atividade.totalHorasProBono}</td>
                                <td>{atividade.totalValorProBono}</td>
                            </tr>
                        ))}
                      </tbody>
                  </table>
              </StyledTablePage>
          </StyledForm>
      </Flex>                            
    </Modal>
  );
};